import { USER_TOKEN_COOKIENAME } from "./../common/env";
import cookie from "js-cookie";

export const getToken = () => cookie.get(USER_TOKEN_COOKIENAME);
